<template>
  <div class="shelves-log">
    <Search ref="search" @search="search"/>
    <Table :list="logList" @show-down-progress="showDownProgress"/>
     <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <!-- 从平台店铺下载进度弹窗和结果弹窗 -->
    <DownloadProgress
      ref="progressDialog"
    >
      <template v-slot:title>
        <span class="down-title">商品下载中...</span>
      </template>
    </DownloadProgress>
    <ShopPlatFromResult ref="shopPlatFromResult" :resultData="shopResultData"/>
    <!-- 从快麦ERP导入进度弹窗和结果弹窗 -->
    <DownloadProgress
      ref="erp_progressDialog"
    >
      <template v-slot:title>
        <span class="down-title">商品导入中...</span>
      </template>
    </DownloadProgress>
    <ShopPlatFromResult ref="erp_shopPlatFromResult" :resultData="erp_shopResultData"/>
  </div>
</template>

<script>
import Search from './components/search.vue';
import Table from './components/table.vue';

import {getOperatorLog} from "@/servers/prod/log"
import { mapGetters, mapActions } from "vuex";
import DownloadProgress from '@/components/prod/center/components/DownloadProgress.vue'
import ShopPlatFromResult from '@/components/prod/center/dialogs/shopPlatFormResult.vue'

export default {
  components: {
    Search,
    Table,
    DownloadProgress,
    ShopPlatFromResult
  },
  data() {
    return {
      logList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      // 从平台商品下载
      shopResultData: {
        successNum: 0,
        totalNum: 0
      }, // 结果
      // 从快麦ERP导入
      erp_shopResultData: {
        successNum: 0,
        totalNum: 0
      }, // 下载商品结果
    }
  },
  computed: {
    ...mapGetters(['subCodeMap']),
  },
  methods: {
    ...mapActions(['fetch_channelByType']),
    search() {
      this.pagination.pageNo = 1;
      this.fetch_operatorLog();
    },
    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetch_operatorLog();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.fetch_operatorLog();
    },
    async fetch_operatorLog() {
      const searchParams = this.$refs.search.method_getSearchForm();
      const {pageNo, pageSize} = this.pagination;
      const _params = {
        ...searchParams,
        operationType: 4,
        pageNo,
        pageSize
      }
      const res = await getOperatorLog(_params);
      if(!res) return;
      const {records, total} = res;
      this.logList = records;
      this.pagination.total = total;
    },
    // 展示弹窗
    showDownProgress(rowData) {
      const subCode = this.subCodeMap[rowData.channel];
      if( subCode == 10) {
        // 从平台店铺下载
        this.fetch_JobResult('DOWNLOAD_PLATFORM_ITEM', rowData)
      } else if(subCode == 11) {
        // 从快麦ERP导入
        this.fetch_erp_JobResult('', rowData)
      }
    },
    // 从平台店铺下载进度查询
    fetch_JobResult(taskTypeEnum, rowData) {
      this.$refs.progressDialog.showDialog()
      this.$refs.progressDialog.calculation_progress(rowData.total)
      this.$refs.progressDialog.queryScmJobResult(taskTypeEnum, (res) => {
        if(res.finished) {
          this.shopResultData =  _.assign(this.resultData, res.result)
          this.$refs.shopPlatFromResult.method_open()
        }
      })
    },
    // erp导入进度查询
    fetch_erp_JobResult(taskTypeEnum, rowData) {
      this.$refs.erp_progressDialog.showDialog()
      this.$refs.erp_progressDialog.calculation_progress(rowData.total)
      this.$refs.erp_progressDialog.queryScmJobResult(taskTypeEnum, (res) => {
        if(res.finished) {
          this.erp_shopResultData = _.assign(this.erp_resultData, res.result);
          this.$refs.erp_shopPlatFromResult.method_open()
        }
      })
    },
  },
  mounted() {
    this.search();
    this.fetch_channelByType({
      type: 4
    });
  },
  deactivated() {
    this.$refs.progressDialog.handleClose();
    this.$refs.erp_progressDialog.handleClose();
  }
}
</script>

<style lang="scss" scoped>
.down-title {
  font-size: 18px;
  padding-bottom: 20px;
  display: inline-block;
  font-weight: 800;
}
</style>
